import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import {useI18n} from "vue3-i18n";
import FormTooltip from "@/components/forms/FormTooltip.vue";
import Card from '@/components/layout/Card.vue';
import MemberActivityParticipantTable from "@/components/tables/MemberActivityParticipantTable.vue";

import {useMemberService} from "@/inversify.config";
import {computed, onMounted, ref} from "vue";
import {ActivityRegistration, Participant} from "@/types";
import {notifyError, notifySuccess} from "@/notify";
import {SucceededOrNotResponse} from "@/types/responses";
import MemberActivityTable from "@/components/tables/MemberActivityTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MemberActivities',
  setup(__props) {

const {t} = useI18n();
const memberService = useMemberService()

const cardTitle = computed(() => isEditMode.value ? t('participants.participants') : t('registrations.registrations'))
const isEditMode = ref(false)

const activityRegistrations = ref<ActivityRegistration[]>([])
const selectedActivityRegistration = ref<ActivityRegistration>()
const participants = ref<Participant[]>([])
const isLessThanTwoDays = ref(false)

onMounted(async () => {
  await fetchActivityRegistration();
})

async function fetchActivityRegistration() {
  let response = await memberService.getCurrentMemberActivityRegistrations()
  activityRegistrations.value = response as ActivityRegistration[];
}

function handleEdit(id: string) {
  let activityRegistration = activityRegistrations.value.find(x => x.id == id)
  selectedActivityRegistration.value = activityRegistration;
  participants.value = activityRegistration?.participants ?? []
  isLessThanTwoDays.value = new Date(activityRegistration?.activityOccurrenceStartDateAndTime ?? "").hoursBetweenToday() < 48
  isEditMode.value = true
}

async function deleteParticipant(participantId: string) {
  let result: SucceededOrNotResponse = await memberService
    .deleteCurrentMemberActivityRegistrationParticipant(selectedActivityRegistration.value?.id ?? "", participantId);

  if (result?.succeeded) {
    notifySuccess(t("participants.form.deleteSuccess"));
    await fetchActivityRegistration();
    let activityRegistration = activityRegistrations.value.find(x => x.id == selectedActivityRegistration.value?.id ?? "")
    participants.value = activityRegistration?.participants ?? []
    isEditMode.value = participants.value.length > 0 // go back to all registrations if no participant is left
  } else {
    notifyError(t("participants.form.deleteError"));
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { title: cardTitle.value }, {
    default: _withCtx(() => [
      (isEditMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(MemberActivityParticipantTable, {
              "activity-registration": selectedActivityRegistration.value,
              "is-less-than-two-days": isLessThanTwoDays.value,
              participants: participants.value,
              onDeleteParticipant: deleteParticipant
            }, null, 8, ["activity-registration", "is-less-than-two-days", "participants"]),
            _createElementVNode("button", {
              class: "btn btn--fullscreen",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isEditMode.value = !isEditMode.value))
            }, _toDisplayString(_unref(t)("global.back")), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(MemberActivityTable, { onActivityRegistrationSelected: handleEdit })
          ])),
      _createVNode(FormTooltip, { class: "util--with-top-margin" }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, [
            _createElementVNode("strong", null, _toDisplayString(_unref(t)('registrations.deleteMemberRegistration--tooltip')), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})